var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayLaterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wrap_text_black_24dp",
    transform: "translate(-22 -29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_38",
    "data-name": "Trac\\xE9 38",
    d: "M0,24H24V0H0Z",
    transform: "translate(22 29)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_39",
    "data-name": "Trac\\xE9 39",
    d: "M5,18.3H19a1,1,0,0,1,0,2H5a1,1,0,0,1,0-2Zm11.83-4H5a1,1,0,0,1,0-2H17.13a2.073,2.073,0,0,0,2.09-1.66A2,2,0,0,0,17.25,8.3H15v.79a.5.5,0,0,1-.85.35l-1.79-1.79a.5.5,0,0,1,0-.71l1.79-1.79A.5.5,0,0,1,15,5.5v.8h2a4,4,0,0,1,3.98,4.39,4.116,4.116,0,0,1-4.15,3.61ZM9,8.3H5a1,1,0,1,1,0-2H9a1,1,0,0,1,0,2Z",
    transform: "translate(22 28)",
    fill: "#currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayLaterIcon);
export default __webpack_public_path__ + "static/media/play-later-icon.031af93f59695adb6744c15fab30e02e.svg";
export { ForwardRef as ReactComponent };